import { render, staticRenderFns } from "./KrausSwitcher.vue?vue&type=template&id=e19995d2&lang=pug&"
import script from "./KrausSwitcher.vue?vue&type=script&lang=js&"
export * from "./KrausSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports